
import Micrositio from '@/components/Micrositios/Micrositio.vue'
import Plantilla from '@/components/Micrositios/Comun/Plantilla.vue';
//import Micrositio from '@/components/PaginaWeb/Comun/Micrositio.vue';

const Micrositios = [
  {
    path: '/Micrositio/', component: Plantilla, children: [     
      { path: 'UIG/:url', component: Micrositio },
      { path: 'IC/:url', component: Micrositio },
      { path: 'JA/:url', component: Micrositio },
      { path: 'UT/:url', component: Micrositio },
      { path: 'SPA/:url', component: Micrositio },
      { path: 'OM/:url', component: Micrositio },
      { path: 'OPDEV/:url',component: Micrositio},
      { path: 'FOR/:url', component: Micrositio},
      { path: 'INFORMACION/:url', component: Micrositio},
      { path: 'CJ/:url', component: Micrositio},
      { path: 'TD/:url', component: Micrositio},
      { path: 'RP/:url', component: Micrositio},
      {
        path: 'AG/:url',
        component: Micrositio
      }
    ]
  }
];

//Se regresa la lista de paths
export default Micrositios;



// WEBPACK FOOTER //
// ./src/router/Micrositios.js